import * as React from 'react';

interface CheckOutOprops extends GatewayProps {
}

interface CheckoutState {
	processing: boolean;
}

export default class CheckoutGateway extends React.Component<CheckOutOprops, CheckoutState> {
	constructor(props) {
		super(props);

		this.state = {
			processing: true
		}
	}

	componentDidMount(): void {
		const { gateway, onMount } = this.props;
		onMount(this.initFrames, [gateway.additionalInfo.checkoutScriptUrl]);
	}

	initFrames = () => {
		const paymentForm = document.getElementById('payment-form') as any;
		const Frames = (window as any).Frames;
		this.setState({ processing: false }, );

		Frames.init({
			publicKey: this.props.gateway.additionalInfo.checkoutPublicKey,
			containerSelector: '.frames-container',
			cardValidationChanged: function () {
				// if all fields contain valid information, the Pay now
				// button will be enabled and the form can be submitted
				// payNowButton.disabled = !Frames.isCardValid();
				this.setState({ processing: !Frames.isCardValid() })
			}.bind(this),
			cardSubmitted: function () {
				this.setState({ processing: true })
				// payNowButton.disabled = true;
				// display loader
			}.bind(this),
			cardTokenised: function (event) {
				var cardToken = event.data.cardToken;
				Frames.addCardToken(paymentForm, cardToken)
				this.props.onTokenReceive(cardToken, this.props.values.serviceName);
			}.bind(this),
			cardTokenisationFailed: function (event) {
				this.setState({ processing: false })
			}.bind(this)
		});

		paymentForm.addEventListener('submit', e => {
			event.preventDefault();
			Frames.submitCard();
		});
	}

	render(): React.ReactNode {
		return (
			<div className="payment-container">
				<h2>CheckoutJS</h2>
				{this.props.errors && this.props.errors.message && <h4 style={{ color: 'red' }}>{this.props.errors.message}</h4>}
				<form id="payment-form">
					<div className="frames-container">
					</div>
					<div style={{ display: (this.state.processing && !this.props.errors) ? 'none' : 'initial' }}>{this.props.payComponent}</div>
				</form>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/parts/checkout.tsx